export default {
  methods: {
    setPageTitle (title) {
      window.document.title += ` | ${title.toLowerCase()}`
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/setPageTitle.js